import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Mail, Lock, LogIn } from "lucide-react";

function Login() {
  const { login }   = useAuth();
  const navigate    = useNavigate();

  const [form,    setForm]    = useState({ email: "", password: "" });
  const [error,   setError]   = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setError(""); // effacer l'erreur à chaque frappe
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const result = await login(form.email, form.password);

    if (!result.success) {
      setError(result.message);
      setLoading(false);
      return;
    }

    // Redirection selon le rôle
    navigate(result.data.role === "admin" ? "/admin" : "/");
    setLoading(false);
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-5">

          <div className="card border-0 rounded-4"
            style={{ boxShadow: "0 8px 32px rgba(0,0,0,0.1)" }}>
            <div className="card-body p-4">

              {/* Header */}
              <div className="text-center mb-4">
                <div className="rounded-3 d-inline-flex p-3 mb-3"
                  style={{ background: "rgba(108,99,255,0.1)" }}>
                  <LogIn size={28} color="#6c63ff" />
                </div>
                <h2 className="fw-bold mb-1">Connexion</h2>
                <p className="text-muted small">Accédez à votre compte</p>
              </div>

              {/* Erreur globale */}
              {error && (
                <div className="alert alert-danger rounded-3 py-2 small d-flex justify-content-between">
                  {error}
                  <button className="btn-close btn-sm" onClick={() => setError("")} />
                </div>
              )}

              <form onSubmit={handleSubmit}>

                {/* Email */}
                <div className="mb-3">
                  <label className="form-label fw-medium small">
                    <Mail size={13} className="me-1" /> Email
                  </label>
                  <input
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    className="form-control rounded-3"
                    placeholder="sara@gmail.com"
                    required
                  />
                </div>

                {/* Mot de passe */}
                <div className="mb-2">
                  <label className="form-label fw-medium small">
                    <Lock size={13} className="me-1" /> Mot de passe
                  </label>
                  <input
                    name="password"
                    type="password"
                    value={form.password}
                    onChange={handleChange}
                    className="form-control rounded-3"
                    placeholder="••••••••"
                    required
                  />
                </div>

                {/* Mot de passe oublié */}
                <div className="text-end mb-3">
                  <Link to="/forgot-password"
                    className="small text-decoration-none"
                    style={{ color: "#6c63ff" }}>
                    Mot de passe oublié ?
                  </Link>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="btn w-100 fw-bold text-white rounded-3 py-2"
                  style={{ background: "#6c63ff" }}>
                  {loading
                    ? <><span className="spinner-border spinner-border-sm me-2" />Connexion...</>
                    : "Se connecter"
                  }
                </button>
              </form>

              <p className="text-center text-muted small mt-3 mb-0">
                Pas encore de compte ?{" "}
                <Link to="/register" className="fw-bold text-decoration-none"
                  style={{ color: "#6c63ff" }}>
                  Inscrivez-vous
                </Link>
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;